import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface SidebarNavLinkProps {
  to: string;
  icon: ReactNode;
  label: string;
  disabled?: boolean;
  tooltip?: string;
  active?: boolean;
}

export const SidebarNavLink = ({
  to,
  icon,
  label,
  disabled = false,
  tooltip,
  active = false,
}: SidebarNavLinkProps) => {
  return (
    <div className="relative group">
      <Link
        to={disabled ? '#' : to}
        className={`flex items-center px-4 py-3 rounded-md ${
          disabled
            ? 'text-gray-500 cursor-not-allowed'
            : active
              ? 'bg-gray-700 text-white'
              : 'text-gray-300 hover:bg-gray-700 hover:text-white'
        }`}
        onClick={(e) => disabled && e.preventDefault()}
      >
        {icon}
        <span className="ml-3">{label}</span>
      </Link>

      {disabled && tooltip && (
        <div className="absolute bottom-full left-0 mb-2 hidden group-hover:block z-50">
          <div className="bg-gray-700 text-white text-sm px-3 py-1 rounded whitespace-nowrap shadow-lg">
            {tooltip}
          </div>
        </div>
      )}
    </div>
  );
};
